import axios from 'axios';
import { call, fork, put } from 'redux-saga/effects';
import { all, takeLatest } from '@redux-saga/core/effects';

import { isClient, isDebug } from '../../configureStore';

import {
  GET_SCHEDULE_FAILURE,
  GET_SCHEDULE_REQUEST,
  GET_SCHEDULE_SUCCESS,
  COMMON_FAILURE,
  GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS,
  GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE,
  GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST,
} from '../../actions';
import scheduleService from '../../services/scheduleService';

/** ********************************************************************
 * スケジュール取得API
 *********************************************************************** */
// const scheduleData = {
//   result: 0,
//   errorMessage: null,
//   programList: [
//     {
//       programId: '001',
//       programName: 'セルフエステ001',
//       selectFlag: 0,
//     },
//     {
//       programId: '002',
//       programName: 'ゴルフ練習打席002',
//       selectFlag: 0,
//     },
//     {
//       programId: '003',
//       programName: 'フィットネスジム003',
//       selectFlag: 1,
//     },
//     {
//       programId: '004',
//       programName: 'フィットネスジム004',
//       selectFlag: 0,
//     },
//     {
//       programId: '005',
//       programName: 'フィットネスジム005',
//       selectFlag: 0,
//     },
//     {
//       programId: '006',
//       programName: 'フィットネスジム006',
//       selectFlag: 0,
//     },
//     {
//       programId: '007',
//       programName: 'フィットネスジム007',
//       selectFlag: 0,
//     },
//   ],
//   scheduleList: [
//     {
//       infoDate: '20250703',
//       week: '金',
//       dayType: 'weekday',
//       contentsList: [
//         {
//           contentsId: '001',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           cancelWaitNotice: 1,
//           frameList: [
//             { startTime: '1101', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1102', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1103', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1104', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1105', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1106', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1107', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1108', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1109', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1110', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1111', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1112', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1113', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1114', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1115', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1116', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1117', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1118', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '002',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 0,
//           cancelWaitNotice: 0,
//           frameList: [
//             { startTime: '1121', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1122', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1123', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1124', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1125', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1126', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1127', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1128', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1129', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1130', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1131', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1132', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1032', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1133', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1134', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1135', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1136', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1137', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1141', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1142', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1143', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1144', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1145', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1146', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1147', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1148', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1149', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1150', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1151', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1152', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1153', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1154', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1155', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1156', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1157', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1158', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250704',
//       week: '土',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250705',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250706',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [
//         {
//           contentsId: '001',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           cancelWaitNotice: 1,
//           frameList: [
//             { startTime: '1101', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1102', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1103', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1104', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1105', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1106', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1107', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1108', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1109', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1110', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1111', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1112', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1113', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1114', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1115', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1116', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1117', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1118', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '002',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 0,
//           cancelWaitNotice: 0,
//           frameList: [
//             { startTime: '1121', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1122', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1123', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1124', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1125', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1126', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1127', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1128', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1129', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1130', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1131', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1132', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1032', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1133', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1134', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1135', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1136', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1137', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1141', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1142', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1143', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1144', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1145', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1146', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1147', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1148', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1149', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1150', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1151', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1152', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1153', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1154', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1155', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1156', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1157', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1158', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250707',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250708',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250709',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//   ],
// };

// const scheduleData = {
//   result: 0,
//   errorMessage: null,
//   programList: [
//     {
//       programId: '001',
//       programName: 'セルフエステ001',
//       selectFlag: 0,
//     },
//     {
//       programId: '002',
//       programName: 'ゴルフ練習打席002',
//       selectFlag: 0,
//     },
//     {
//       programId: '003',
//       programName: 'フィットネスジム003',
//       selectFlag: 1,
//     },
//     {
//       programId: '004',
//       programName: 'フィットネスジム004',
//       selectFlag: 0,
//     },
//     {
//       programId: '005',
//       programName: 'フィットネスジム005',
//       selectFlag: 0,
//     },
//     {
//       programId: '006',
//       programName: 'フィットネスジム006',
//       selectFlag: 0,
//     },
//     {
//       programId: '007',
//       programName: 'フィットネスジム007',
//       selectFlag: 0,
//     },
//   ],
//   scheduleList: [
//     {
//       infoDate: '20250703',
//       week: '金',
//       dayType: 'weekday',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250704',
//       week: '土',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250705',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250706',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250707',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250708',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250709',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//   ],
// };

// const resConfirmData = {
//   result: 0,
//   errorMessage: null,
//   contentsName: 'フィットネスジビジター無制限',
//   annexFlag: 0,
//   contentsComment: '予約に関する注意事項001\\n予約に関する注意事項002',
//   cancelTime: '11/19(水)00:01',
//   companionUpperLimit: 2,
//   scheduleReservationList: [
//     {
//       eqsId: 111,
//       eqsName: 'A',
//       annexFlag: 1,
//       remaining: 0,
//       nickName: 'ニックネームAA',
//       spaceName: 'スペースネームAA',
//       bookFlag: 0,
//     },
//     {
//       eqsId: 222,
//       eqsName: 'B',
//       annexFlag: 0,
//       remaining: 0,
//       nickName: 'ニックネームBB',
//       spaceName: 'スペースネームBB',
//       bookFlag: 0,
//     },
//     {
//       eqsId: 333,
//       eqsName: 'C',
//       annexFlag: 1,
//       remaining: 0,
//       nickName: 'ニックネームCC',
//       spaceName: 'スペースネームCC',
//       bookFlag: 1,
//     },
//   ],
// };

function* getSchedule(action: any): Generator<any> {
  try {
    // console.log(action);
    const res: any = yield call(scheduleService(action).getSchedule);
    // console.log('getSchedule response:', res.data);
    // const res: any = scheduleData;
    yield put({
      type: GET_SCHEDULE_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_SCHEDULE_FAILURE,
        error,
      });
      yield put({
        type: COMMON_FAILURE,
        response: error.response,
      });
      if (isClient && isDebug) {
        action.history.push('/systemError');
      } else {
        action.history.push('/systemError');
      }
    }
  }
}

function* getReserveConfirm(action: any): Generator<any> {
  try {
    const res: any = yield call(scheduleService(action).getReserveConfirmData);
    // const res: any = resConfirmData;
    yield put({
      type: GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE,
        error,
      });
      yield put({
        type: COMMON_FAILURE,
        response: error.response,
      });
      if (isClient && isDebug) {
        action.history.push('/systemError');
      } else {
        action.history.push('/systemError');
      }
    }
  }
}

function* watchGetSchedule() {
  yield takeLatest(GET_SCHEDULE_REQUEST, getSchedule);
}

function* watchGetReserveConfirm() {
  yield takeLatest(GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST, getReserveConfirm);
}

export default function* ScheduleSaga() {
  yield all([fork(watchGetSchedule), fork(watchGetReserveConfirm)]);
}
